export const getColor = (position) => {
  if (position === 0 || position === 3 || position === 6 || position === 9) {
    return '09798D';
  }
  if (position === 1 || position === 4 || position === 7 || position === 10) {
    return '17BFDD';
  }
  if (position === 2 || position === 5 || position === 8 || position === 11) {
    return 'F3A802';
  }
};
